export type ForecastFormType = 'budget' | 'fixed' | 'legacy' | 'rolling';

interface ForecastForFormType {
  include_unpaid_invoices?: boolean;
  kind?: 'budget' | 'live' | 'scenario';
}

/**
 * Formats an API date for the forecast form.
 *
 * @param date - API date formatted as `yyyy-MM-dd`.
 * @returns The date formatted as `dd/MM/yyyy`, or an empty value when absent.
 */
export const formatDateForForm = (date?: string | null): string => {
  if (!date) {
    return '';
  }

  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

/**
 * Classifies a forecast into the form variant it requires.
 * Consolidated scenarios are always fixed because they do not support invoice-based rolling forecasts.
 *
 * @param forecast - Forecast list item being edited or duplicated.
 * @param isConsolidation - Whether the forecast belongs to a consolidation.
 * @returns The matching budget, fixed, rolling, or legacy form type.
 */
export const getForecastFormType = (
  forecast?: ForecastForFormType,
  isConsolidation = false
): ForecastFormType => {
  if (forecast?.kind === 'budget') {
    return 'budget';
  }

  if (forecast?.kind === 'scenario') {
    return !isConsolidation && forecast.include_unpaid_invoices ? 'rolling' : 'fixed';
  }

  return 'legacy';
};
